import React from 'react';
import { Card } from './ui/card';
import { Heart, Users, Camera, Image } from 'lucide-react';
import { services } from '../mock';

const iconMap = {
  Heart: Heart,
  Users: Users,
  Camera: Camera,
  Image: Image
};

const Services = () => {
  return (
    <section id="services" className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-4 bg-gradient-to-r from-cyan-600 to-teal-600 bg-clip-text text-transparent">
            Services
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Professional photography services tailored to your needs
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group relative overflow-hidden border-none shadow-lg hover:shadow-2xl transition-all duration-500 bg-white"
              >
                {/* Gradient overlay on hover */}
                <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/0 to-teal-500/0 group-hover:from-cyan-500/10 group-hover:to-teal-500/10 transition-all duration-500"></div>
                
                <div className="relative p-8">
                  {/* Icon */}
                  <div className="mb-6 inline-flex p-4 rounded-2xl bg-gradient-to-br from-cyan-100 to-teal-100 group-hover:from-cyan-500 group-hover:to-teal-500 transition-all duration-500">
                    <IconComponent className="w-8 h-8 text-cyan-600 group-hover:text-white transition-colors duration-500" />
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-bold text-slate-800 mb-3 group-hover:text-cyan-600 transition-colors duration-300">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    {service.description}
                  </p>
                </div>

                {/* Bottom accent line */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-cyan-500 to-teal-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
